import Immutable from "seamless-immutable";

import { CLEAR_BADGES, LOGOUT, IMPERSONATE_USER, STOP_IMPERSONATE_USER, GET_EMAIL_PREFERENCES_RESPONSES, CREATE_EMAIL_PREFERENCES, UPDATE_EMAIL_PREFERENCES } from "../actions/Types";

// initial state

const initialState = Immutable({
  items: [],
});

// reducers

const setResponses = (state, action) => {
  const { data } = action;
  return Immutable.merge(state, { items: data });
};

const setUpdatePrefernces = (state, action) => {
  const { items } = action;
  return Immutable.merge(state, { items: items });
};

const setAddPreference = (state, action) => {
  const { items } = action;
  return Immutable.merge(state, { items: items });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_EMAIL_PREFERENCES_RESPONSES:
      return setResponses(state, action);
    case UPDATE_EMAIL_PREFERENCES:
      return setUpdatePrefernces(state, action);
    case CREATE_EMAIL_PREFERENCES:
      return setAddPreference(state, action);
    case IMPERSONATE_USER:
    case STOP_IMPERSONATE_USER:
    case CLEAR_BADGES:
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
